module.exports = __webpack_public_path__ + "static/media/3.0597c693.png";